import { ROUTE_NAMES } from 'src/router/routeNames.const'
import type { RouteConfig } from 'vue-router'

export const routeMinor = ((): RouteConfig => {
  return {
    path: '/minor',
    name: ROUTE_NAMES.minorCircuit.minorPagesContainer,
    component: () =>
      import(
        /* webpackChunkName: "MinorCircuit" */ 'src/circuits/minor-circuit/MinorCircuitContainerView.vue'
      ),
  }
})()
